import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,  // ログイン cookie を送信
});

// 401 を検知して自動的にログイン画面に戻す
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      // ページに通知 → App.js が捕捉
      window.dispatchEvent(new CustomEvent('xap:unauthorized'));
    }
    return Promise.reject(err);
  }
);

export const tweetsAPI = {
  getAll: (params) => api.get('/tweets', { params }),
  create: (data) => api.post('/tweets', data),
  update: (id, data) => api.put(`/tweets/${id}`, data),
  delete: (id) => api.delete(`/tweets/${id}`),
  postNow: (id) => api.post(`/tweets/${id}/post`),
  getHistory: () => api.get('/tweets/history/all'),
};

export const scheduleAPI = {
  getAll: () => api.get('/schedule'),
  getUpcoming: () => api.get('/schedule/upcoming'),
  create: (data) => api.post('/schedule', data),
  cancel: (id) => api.delete(`/schedule/${id}`),
};

export const authAPI = {
  getSettings: () => api.get('/auth/settings'),
  saveSettings: (data) => api.post('/auth/settings', data),
  verify: () => api.post('/auth/verify'),
};

export const aiAPI = {
  generate: (data) => api.post('/ai/generate', data),
  saveApiKey: (apiKey) => api.post('/ai/apikey', { apiKey }),
};

export const loginAPI = {
  me: () => api.get('/login/me'),
  request: (email) => api.post('/login/request', { email }),
  logout: () => api.post('/login/logout'),
};

export default api;
